module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('home')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    attrs: {
      "id": "home"
    }
  }, [_c('nav', {
    staticClass: "header_navbar"
  }, [_c('ul', {
    staticClass: "header_navbar_menu"
  }, [_c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#home"
    }
  }, [_vm._v("Strona Główna")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#aboutUs"
    }
  }, [_vm._v("O nas")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#members"
    }
  }, [_vm._v("Nasza kompania")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#events"
    }
  }, [_vm._v("Larpy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_c('h1', {
    staticClass: "header_title_name"
  }, [_vm._v("KRASJA")]), _vm._v(" "), _c('hr', {
    staticClass: "header_title_line"
  }), _vm._v(" "), _c('h2', {
    staticClass: "header_title_slogan"
  }, [_vm._v(" Daj się porwać w wir przygody!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0493d8a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 27
// module chunks = 0